import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import {
  BEGIN, CREATE, DELETE_BY_ID, FAILED, SUCCESSFUL, UPDATE,
} from '../../configs/actionNames';
import { VIOLATIONS_MODULE } from '../../configs/moduleNames';

export const LOAD_VIOLATIONS_LIST = '_LOAD_VIOLATIONS_LIST';
export const LOAD_VIOLATIONS_BY_ID = '_LOAD_VIOLATIONS_BY_ID';
export const LOAD_CONTROL_WORK_VIOLATIONS_LIST = '_LOAD_CONTROL_WORK_VIOLATIONS_LIST';
export const LOAD_CONTROL_WORK_VIOLATIONS_BY_ID = '_LOAD_CONTROL_WORK_VIOLATIONS_BY_ID';
export const IMPORT = '_IMPORT';
export const EXPORT_WORK_CONTROL = '_EXPORT_WORK_CONTROL';

export const loadViolationsList = createDeferredAction(VIOLATIONS_MODULE + LOAD_VIOLATIONS_LIST);
export const loadViolationsListSuccessful = createAction(VIOLATIONS_MODULE + LOAD_VIOLATIONS_LIST + SUCCESSFUL);
export const loadViolationsListFailed = createAction(VIOLATIONS_MODULE + LOAD_VIOLATIONS_LIST + FAILED);
export const loadViolationsListBegin = createAction(VIOLATIONS_MODULE + LOAD_VIOLATIONS_LIST + BEGIN);

export const loadViolationsById = createDeferredAction(VIOLATIONS_MODULE + LOAD_VIOLATIONS_BY_ID);
export const loadViolationsByIdSuccessful = createAction(VIOLATIONS_MODULE + LOAD_VIOLATIONS_BY_ID + SUCCESSFUL);
export const loadViolationsByIdFailed = createAction(VIOLATIONS_MODULE + LOAD_VIOLATIONS_BY_ID + FAILED);

export const importViolation = createDeferredAction(VIOLATIONS_MODULE + IMPORT);
export const importViolationSuccessful = createAction(VIOLATIONS_MODULE + IMPORT + SUCCESSFUL);
export const importViolationFailed = createAction(VIOLATIONS_MODULE + IMPORT + FAILED);

export const loadControlWorkViolationsList = createDeferredAction(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_LIST);
export const loadControlWorkViolationsListSuccessful = createAction(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_LIST + SUCCESSFUL);
export const loadControlWorkViolationsListFailed = createAction(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_LIST + FAILED);
export const loadControlWorkViolationsListBegin = createAction(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_LIST + BEGIN);

export const loadControlWorkViolationById = createDeferredAction(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_BY_ID);
export const loadControlWorkViolationByIdSuccessful = createAction(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_BY_ID + SUCCESSFUL);
export const loadControlWorkViolationByIdFailed = createAction(VIOLATIONS_MODULE + LOAD_CONTROL_WORK_VIOLATIONS_BY_ID + FAILED);

export const createViolation = createDeferredAction(VIOLATIONS_MODULE + CREATE);
export const createViolationSuccessful = createAction(VIOLATIONS_MODULE + CREATE + SUCCESSFUL);
export const createViolationFailed = createAction(VIOLATIONS_MODULE + CREATE + FAILED);

export const editViolation = createDeferredAction(VIOLATIONS_MODULE + UPDATE);
export const editViolationSuccessful = createAction(VIOLATIONS_MODULE + UPDATE + SUCCESSFUL);
export const editViolationFailed = createAction(VIOLATIONS_MODULE + UPDATE + FAILED);

export const deleteViolation = createDeferredAction(VIOLATIONS_MODULE + DELETE_BY_ID);
export const deleteViolationSuccessful = createAction(VIOLATIONS_MODULE + DELETE_BY_ID + SUCCESSFUL);
export const deleteViolationFailed = createAction(VIOLATIONS_MODULE + DELETE_BY_ID + FAILED);

export const exportWorkControl = createDeferredAction(VIOLATIONS_MODULE + EXPORT_WORK_CONTROL);
export const exportWorkControlSuccessful = createAction(VIOLATIONS_MODULE + EXPORT_WORK_CONTROL + SUCCESSFUL);
export const exportWorkControlFailed = createAction(VIOLATIONS_MODULE + EXPORT_WORK_CONTROL + FAILED);
